import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PressKitBreadcrumbResolver } from '@modules/content-api/resolver/press-kit.resolver';
import { LightboxPageComponent } from '@modules/shared/lightbox/lightbox-page.component';

import { PressKitPageComponent } from './press-kit-page.component';

const routes: Routes = [
  {
    path: '',
    component: PressKitPageComponent,
    resolve: {
      breadcrumb: PressKitBreadcrumbResolver,
    },
    data: {
      acceptsKeptBreadcrumbs: true,
    },
    children: [
      {
        path: ':resourceType/:resourceId',
        component: LightboxPageComponent,
        outlet: 'lightbox',
      },
    ],
  },
  {
    // TODO: this should be a child route of press-kit
    path: 'article/:id',
    resolve: {
      breadcrumb: PressKitBreadcrumbResolver,
    },
    loadChildren: () =>
      import('../press-kit-article-page/press-kit-article-page.module').then((m) => m.PressKitArticlePageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PressKitPageRoutingModule {}
